/**
 * AppName for STOMP CONNECT + chat REST.
 * Required by client-user-apps-recent-visits.md — never omit or server stores "CLIENT".
 */
export const APP_NAME = "CORPORATE";
